var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"white-space":"normal"}},_vm._l((_vm.progressInfo),function(progress,index){return _c('div',{key:index},[_c('div',[_c('span',[_vm._v(_vm._s(progress.message))])]),_c('div',[_c('span',[_vm._v(_vm._s(progress.status))]),_vm._v("   "),_c('span',[_vm._v(_vm._s(_vm.handlePro(progress.progressRate))+"%")])])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }